<template>
  <div v-loading="loading" style="padding: 20px">
    <div
      v-if="(itemList && itemList.length > 0) || (serviceList && serviceList.length > 0)"
    >
      <div v-if="serviceList && serviceList.length > 0">
        <div class="order-service-title">服务清单</div>
        <template v-for="(service, i) in serviceList">
          <div class="order-item">
            <warehouse-service-info :serviceInfo="service.serviceInfo" :imageSize="40" />
            <div>
              <div v-if="service.optRemark">
                <div class="wordwrap">
                  备注:
                  <span class="item-remark">{{ service.optRemark }}</span>
                </div>
              </div>
            </div>
            <div class="item-count">
              <div>
                <span class="status-label">服务</span>
                <div class="count-label">
                  <span style="margin-right: 5px">
                    单价: {{ service.servicePrice || 0 }}
                  </span>
                  <span style="margin-right: 5px">
                    数量: {{ service.serviceCount || 0 }}
                  </span>
                  <span style="margin-right: 5px">
                    金额: {{ service.totalAmount || 0 }}元
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div v-if="itemList && itemList.length > 0">
        <div class="order-item-title">商品清单</div>
        <template v-for="(item, i) in itemList">
          <div class="order-item">
            <warehouse-goods-info :goodsInfo="item.goodsInfo" />
            <div class="shelf-info">
              <span>
                {{ item.goodsInfo.shelfList }}
              </span>
              <span style="color: #3399ff; margin-left: 5px">
                <span> 库存数量: </span>
                <span>
                  {{ item.goodsInfo.stockCount || "0" }}
                </span>
              </span>
              <span
                v-if="item.goodsInfo.lastValidTime > 0"
                style="color: #333333; margin-left: 5px"
              >
                <span> 有效日期: </span>
                <span>
                  {{ new Date(item.goodsInfo.lastValidTime).format("YYYY-MM-dd") || "" }}
                </span>
              </span>
            </div>
            <div>
              <div v-if="item.optRemark">
                <div class="wordwrap">
                  备注:
                  <span class="item-remark">{{ item.optRemark }}</span>
                </div>
              </div>
            </div>
            <div class="item-count">
              <div>
                <span class="status-label">商品</span>
                <div class="count-label">
                  <span style="margin-right: 5px">
                    单价: {{ item.goodsPrice || 0 }}
                  </span>
                  <span style="margin-right: 5px">
                    数量: {{ item.goodsCount || 0 }}
                  </span>
                  <span style="margin-right: 5px">
                    金额: {{ item.totalAmount || 0 }}元
                  </span>
                  <span v-if="item.inventoryCount > 0" style="margin-right: 5px">
                    已出库: {{ item.inventoryCount || 0 }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchList" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.item-count {
  padding: 5px 10px;
  background-color: #f1f1f1;
  margin-bottom: 20px;
  color: #444444;

  .status-label {
    margin-right: 5px;
    font-weight: bolder;
    color: #000000;
  }

  .count-label {
    color: #000000;
    float: right;
  }
}

.order-service-title {
  color: #919191;
  margin-bottom: 10px;
}

.order-item-title {
  color: #919191;
  margin-top: 30px;
  margin-bottom: 10px;
}

.order-item {
  .item-remark {
    font-weight: bolder;
    color: #e87431;
  }
}

.shelf-info {
  font-size: 20px;
  font-weight: bolder;
  margin-bottom: 10px;
  color: #e87431;
}
</style>

<script>
import warehouseGoodsInfo from "../../../../components/business/warehouseGoodsInfo.vue";
import warehouseServiceInfo from "../../../../components/business/warehouseServiceInfo.vue";

export default {
  components: {
    warehouseGoodsInfo,
    warehouseServiceInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        storeGuid: this.pageParams.storeGuid,
        orderGuid: this.pageParams.guid,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      serviceList: null,
      itemList: null,
    };
  },
  methods: {
    fetchList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      return this.requestApi("biz.warehouse.order.item.list", this.defaultParams)
        .then((itemResp) => {
          return this.requestApi(
            "biz.warehouse.order.service.list",
            this.defaultParams
          ).then((resp) => {
            this.itemList = itemResp.data.list || [];
            this.serviceList = resp.data.list || [];
          });
        })
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.fetchList();
  },
};
</script>
